/* eslint-disable jira/integration/test-id-by-folder-structure */
/* eslint-disable jira/naming/disallow-filenames */
/** @jsx jsx */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { jsx } from '@compiled/react';
import IconButton from '@atlaskit/button/icon/button';
// eslint-disable-next-line no-restricted-imports, jira/restricted/@atlaskit+dropdown-menu
import DropdownMenu from '@atlaskit/dropdown-menu/dropdown-menu';
import type { CustomTriggerProps } from '@atlaskit/dropdown-menu/types';
import AddIcon from '@atlaskit/icon/core/add';
import { AsyncFlyoutMenuContent } from './AsyncFlyoutMenuContent.tsx';
import type { BoardCreateFlyoutMenuProps } from './BoardCreateFlyoutMenuProps.types.tsx';

export const DefaultTrigger = ({ triggerRef, ...props }: CustomTriggerProps): JSX.Element => {
	return (
		<IconButton
			{...props}
			icon={AddIcon}
			label="create board"
			ref={triggerRef}
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="software-board-create.ui.flyout-menu.trigger"
		/>
	);
};

export const BoardCreateFlyoutMenu = ({
	renderTrigger: Trigger = DefaultTrigger,
	...props
}: BoardCreateFlyoutMenuProps): JSX.Element => (
	<DropdownMenu<HTMLButtonElement> trigger={Trigger} shouldRenderToParent>
		<AsyncFlyoutMenuContent {...props} />
	</DropdownMenu>
);
